export const WaybillImage = () => {
  return (
    <svg
      width="113"
      height="112"
      viewBox="0 0 113 112"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28.5003 102.667H84.5003C89.6551 102.667 93.8337 98.488 93.8337 93.3332V45.8659C93.8337 43.3905 92.8504 41.0166 91.0999 39.2662L63.9007 12.0669C62.1503 10.3166 59.7763 9.33325 57.3011 9.33325H28.5003C23.3457 9.33325 19.167 13.5119 19.167 18.6666V93.3332C19.167 98.488 23.3457 102.667 28.5003 102.667Z"
        fill="white"
        stroke="#15112D"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M61.167 11.6667V42.0001H89.167"
        stroke="#0B0C0E"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37.833 79.3333H70.4997"
        stroke="#0B0C0E"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37.833 60.6667H70.4997"
        stroke="#0B0C0E"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37.833 42H42.4997"
        stroke="#0B0C0E"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
